import type { AxiosResponse } from 'axios'
import { axiosApi } from '@/services/http/axiosApi'
import {
  API_GET_COMPANY_UPLOAD_FILES,
  API_GET_COMPANY_DOCUMENTS,
  API_SET_COMPANY_DOCUMENT,
  API_DELETE_COMPANY_DOCUMENT
} from '@/constants/urls'
import type { SCAN_STATUS, DOCUMENT_TYPE } from '@/constants/document'

export interface SetCompanyResponse {
  fileId: string
  status: SCAN_STATUS
  uploadDateTime: string
}

export interface UploadResponse {
  id: string
  status: SCAN_STATUS
  type: DOCUMENT_TYPE
  name: string
  uploadDateTime: string
}

export type GetUploadsResponse = UploadResponse[]

export interface DocumentResponse {
  id: string
  uploadDateTime: string
  type: DOCUMENT_TYPE
  name: string
  url: string
}

export type GetDocumentsResponse = DocumentResponse[]

export const getUploadFiles = async (
  companyId: string
): Promise<AxiosResponse<GetUploadsResponse>> =>
  axiosApi.get(API_GET_COMPANY_UPLOAD_FILES(companyId))

export const getDocuments = async (
  companyId: string
): Promise<AxiosResponse<GetDocumentsResponse>> =>
  axiosApi.get(API_GET_COMPANY_DOCUMENTS(companyId))

export const setDocument = async (
  companyId: string,
  file: File,
  documentType: DOCUMENT_TYPE
): Promise<AxiosResponse<SetCompanyResponse>> => {
  const formData = new FormData()
  formData.append('type', documentType)
  formData.append('file', file)

  return axiosApi.post(API_SET_COMPANY_DOCUMENT(companyId), formData)
}

export const deleteDocument = async (
  companyId: string,
  documentId: string
): Promise<AxiosResponse<void>> =>
  axiosApi.delete(API_DELETE_COMPANY_DOCUMENT(companyId, documentId))
